import React, { useRef } from "react";
import { Button } from "../../../../components/ui/button";
import { motion, useInView } from "framer-motion";

const textVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15, // Slightly faster delay for mobile
      duration: 0.6, // Shorter duration for smoother mobile experience
      ease: "easeOut",
    },
  }),
};

const DesktopViewSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-50px" });

  return (
    <section
      ref={sectionRef}
      className="relative w-full min-h-[600px] sm:h-[961px] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/photographer.svg')" }}
    >
      <div className="relative w-full max-w-[1400px] h-full mx-auto px-4 sm:px-6 md:px-10">
        <div className="absolute inset-0 z-10">
          {[
            "The Most Inspiring",
            "Travel Adventures",
            "Fuel Our next",
            "Escape.",
          ].map((text, index) => {
            const isHighlight = text.includes("Travel") || text === "Escape.";
            const textParts = text.split(" ");
            return (
              <motion.h1
                key={index}
                custom={index}
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                variants={textVariants}
                className={`absolute font-handrawn font-normal text-[40px] sm:text-[60px] md:text-[80px] lg:text-[80px] leading-tight whitespace-nowrap ${
                  index === 0
                    ? "top-4 sm:top-5 left-0 text-white"
                    : index === 1
                    ? "top-[80px] sm:top-[130px] md:top-[160px] left-0"
                    : index === 2
                    ? "top-[140px] sm:top-[240px] md:top-[300px] left-0 text-white"
                    : "top-[200px] sm:top-[340px] md:top-[420px] left-0 text-[#ffae00]"
                }`}
              >
                {textParts.map((word, i) => (
                  <span
                    key={i}
                    className={
                      word === "Travel" || word === "Escape."
                        ? "text-[#ffae00]"
                        : "text-white"
                    }
                  >
                    {word + " "}
                  </span>
                ))}
              </motion.h1>
            );
          })}

          {/* Photographer label */}
          <motion.div
            custom={4}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            variants={textVariants}
            className="absolute top-[280px] sm:top-[460px] md:top-[610px] left-0 font-handrawn text-white text-[20px] sm:text-[28px] md:text-[36px]"
          >
            - Ritesh, Photographer
          </motion.div>

          {/* Button */}
          <motion.div
            custom={5}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            variants={textVariants}
          >
            <Button
              variant="outline"
              className="absolute top-[340px] sm:top-[520px] md:top-[700px] left-0 rounded-2xl border-2 border-[#f1f1f1] bg-[#1D1C1F] hover:bg-white/10 px-4 py-2 sm:px-6 sm:py-3"
            >
              <span className="font-bold text-[#ffae00] text-base sm:text-lg md:text-xl tracking-[0.20px] leading-6 sm:leading-7 font-bricolage">
                Request Invite
              </span>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DesktopViewSection;
